import { Component, OnInit } from '@angular/core'
import { FeaturedProductService } from '../../../product/services/featured-product.service'
import { DataAnalyticsClickSource, DataAnalyticsEventLabel } from '../../mb-constants'

@Component({
  selector: 'mb-featured-products-component',
  templateUrl: './featured-products.component.html',
  styleUrls: []
})
export class FeaturedProductsComponent implements OnInit {

  /**
   * TODO Warning! As soon as there is a second usage of this component, we should implement a wrapper component
   * that defines the analytics properties. For page slot where we want to use this component there should be a unique
   * wrapper component that is used nowhere else.
   */
  dataAnalyticsClickSource = DataAnalyticsClickSource.RECOMMENDED_PRODUCTS_CART
  dataAnalyticsEventLabel = DataAnalyticsEventLabel.ADD_TO_CART
  references$ = this.featuredProductsService.getProducts()
  title = 'mbproduct.recommendedProducts'
  constructor (protected featuredProductsService: FeaturedProductService) { }

  ngOnInit (): void {
  }
}
